import {
  CookieCollection,
  getUrlParameter,
  modalalert,
  updateHeaderPrice
} from './script';
import * as api from './api';
import { DatePricing, Pax, ProductPricingMulti, SelectedRoom, ProductPriceList } from './models';
import * as log from 'loglevel';
import * as _ from 'lodash';
// @ts-ignore
import moment from 'moment';
import { LEGAL_ADULT_AGE } from './constant';

const PACKAGE_INVALID_GENERIC_MSG =
  'This package is unavailable for the dates selected.';
// noinspection JSUnusedLocalSymbols
const PACKAGE_INVALID_MAX_NIGHT_MSG =
  'This package is unavailable for the dates selected. Roar &amp; Snore is a single night event.';
const ROOM_ROW_ALERT_HTML_TEMPLATE = _.template(
  '<div><i class="fa fa-exclamation" style="color: #ff0000; padding-right: 0.5em;"></i><span style="color: #000000;"><%= msg %></span></div>'
);

/**
 * Get alert html from template and 'msg' parameter
 */
function getRoomRowAlertHtml(msg) {
  return ROOM_ROW_ALERT_HTML_TEMPLATE({ msg: msg });
}

function isRrpValid(datePricingList: DatePricing[]) {
  if (datePricingList.length == 0) {
    return false;
  }
  return _.every(datePricingList, (p) => p.rrp > 0);
}

/**
 * Check is first date of booking can take arrival
 */
function canTakeArrival(datePricingList: DatePricing[]) {
  if (datePricingList.length == 0) {
    return false;
  }
  const sort = function(p) {
    return p.dateCheckIn;
  };
  const sortedList = _.sortBy<DatePricing>(datePricingList, sort);
  return !sortedList[0].cta;
}

function canTakeDeparture(datePricingList: DatePricing[]) {
  if (datePricingList.length == 0) {
    return false;
  }

  const sort = function(p) {
    return p.dateCheckOut;
  };
  const sortedList = _.sortBy<DatePricing>(datePricingList, sort);
  return !sortedList[sortedList.length - 1].ctd;
}

/**
 * Check is any date of date pricing list has stop sell flag set
 */
function canSell(datePricingList: DatePricing[]) {
  if (datePricingList.length == 0) {
    return false;
  }

  const test = function(p) {
    return !p.stopSell;
  };
  return _.every(datePricingList, test);
}

function isMinNightsValid(datePricingList: DatePricing[], nights) {
  /** @param {DatePricing} p */
  const map = function(p) {
    return p.minNights;
  };
  const minNights = _.min(_.map(datePricingList, map));
  // if value is 0, means no limit
  if (minNights == 0) {
    return true;
  }
  return !minNights ? false : minNights <= nights;
}

function isMaxNightsValid(datePricingList: DatePricing[], nights) {
  /** @param {DatePricing} p */
  const map = function(p) {
    return p.maxNights;
  };
  const maxNights = _.max(_.map(datePricingList, map));
  // if value is 0, means no limit
  if (maxNights == 0) {
    return true;
  }
  return !maxNights ? false : maxNights >= nights;
}

function getMinAvailability(datePricingList: DatePricing[]) {
  // test min availability
  const minAvailability = _.min(
    _.map(datePricingList, function(p) {
      return p.availability;
    })
  );
  return !minAvailability ? 0 : minAvailability;
}

function clearSelectedButtonStyle() {
  // reset selected button style
  const $selected = $('.addtoBasket.selected');
  $selected.find('.btn.btn-green').text('SELECT');
  $selected.removeClass('selected');
}

function updateSelectButtonsStyle(element) {
  clearSelectedButtonStyle();
  // set selected button style
  const $addToBasket = element.parents('.addtoBasket');
  $addToBasket.addClass('selected');
  $addToBasket.find('.btn.btn-green').text('SELECTED');
}

/**
 * Handle addtoBasket click event
 */
function handleProductSelectButtonClicked(e) {
  e.preventDefault();

  log.debug('handleAddToBasketClick called');

  if (!e.target) {
    log.error('e.target is null');
    return;
  }

  const $this = $(e.target);
  if (!$this.hasClass('btn-green')) {
    log.error('button should has class btn-green');
    return;
  }

  const $roomRow = $this.parents('.roomrow');

  // return if room is not available
  if (!$roomRow.hasClass('available')) {
    log.debug('room is not available');
    return;
  }

  const selectedRooms = CookieCollection.SelectedRooms.get() || [];

  const $addToBasket = $this.closest('.addtoBasket');
  const productId = $addToBasket.data('product-id');
  const productName = $addToBasket.data('product-name');
  const rateName = $addToBasket.data('rate-name');

  if (!productId) {
    log.error('product-id not set');
    return;
  }
  const rateCode = $addToBasket.data('rate-code');
  if (!rateCode) {
    log.error('rate-code not set');
    return;
  }
  const productRateCode = $addToBasket.data('product-rate-code');
  if (!productRateCode) {
    log.error('product-rate-code not set');
    return;
  }

  const availability = $addToBasket.data('availability');
  //const priceStr = $addToBasket.data('price');
  const price = $addToBasket.data('price');
  const priceBeforeDiscount = $addToBasket.data('total-before-discount');

  if (!price) {
    log.error('price should not be undefined');
    return;
  }
  // const roomMax = getUrlParameter('roommax');
  const currentRoomStr = getUrlParameter('rc');
  if (!currentRoomStr) {
    log.error('rc should not be undefined');
    return;
  }
  const currentRoom = parseInt(currentRoomStr);
  let sameProductCount = 1;

  for (let i = 0; i < selectedRooms.length; i++) {
    if (selectedRooms[i].room == currentRoom) {
      selectedRooms.splice(i, 1);
    }
  }

  for (let j = 0; j < selectedRooms.length; j++) {
    if (selectedRooms[j].productId == productId) {
      sameProductCount++;
    }
  }

  if (sameProductCount > availability) {
    modalalert('Not enough rooms of this type available', 'error', false);
  } else {
    const thisRoom: SelectedRoom = {
      productId: productId,
      productName: productName,
      rateCode: rateCode,
      productRateCode: productRateCode,
      rateName: rateName,
      room: currentRoom,
      // price: parseFloat(priceStr),
      price: price,
      priceBeforeDiscount: priceBeforeDiscount,
      checkIn: getUrlParameter('s') || false,
      checkOut: getUrlParameter('e') || false,
      questions: []
    };

    $(`[data-product-question][data-product-id="${productId}"]`).each(
      (index, element) => {
        const question = $(element).val() as string;
        thisRoom.questions.push(question);
      }
    );

    selectedRooms.push(thisRoom);
    CookieCollection.SelectedRooms.set(selectedRooms);

    updateSelectButtonsStyle($this);

    // modalalert('Added to cart', 'success', false);

    const $checkOut = $('#nextwrapper .checkout');
    const roomSelected = $('.addtoBasket.selected').length == 1;
    if (roomSelected) {
      $checkOut.removeClass('disabled');
    } else {
      if (!$checkOut.hasClass('disabled')) {
        $checkOut.addClass('disabled');
      }
    }

    updateHeaderPrice();
  }

  // to do: scroll to #nextwrapper
}

function checkAvailability(
  datePricingList: DatePricing[],
  $this,
  nights: number
) {
  let available = true;
  if (!datePricingList) {
    $this.addClass('no-data');
    available = false;
  } else {
    if (!isRrpValid(datePricingList)) {
      $this.addClass('invalid-rrp');
      available = false;
    }

    if (!canTakeArrival(datePricingList)) {
      $this.addClass('cta');
      available = false;
    }

    if (!canTakeDeparture(datePricingList)) {
      $this.addClass('ctd');
      available = false;
    }

    if (!canSell(datePricingList)) {
      $this.addClass('stop-sell');
      available = false;
    }

    if (!isMinNightsValid(datePricingList, nights)) {
      $this.addClass('invalid-min-nights');
      available = false;
    }

    if (!isMaxNightsValid(datePricingList, nights)) {
      $this.addClass('invalid-max-nights');
      available = false;
    }
  }

  const minAvailability = getMinAvailability(datePricingList);
  if (minAvailability <= 0) {
    $this.addClass('not-available');
    available = false;
  }

  if (available) {
    $this.attr('data-any-availability', 'true');
  }

  return { available, minAvailability };
}

const addToBasketTemplate = _.template($('#add-to-basket-template').html());

function setupRow(
  index: number,
  $this: JQuery,
  branchId: number,
  rateCode: string,
  rateName: string,
  datePricingList: DatePricing[],
  nights: number
) {
  log.debug('datePricingList', datePricingList);

  const $addToBasketList = $this.find('.addtoBasketList');
  var productPriceList: ProductPriceList[] = []; 

  // group by product id
  const productGroup = _.groupBy<DatePricing>(datePricingList, (p) => {
    // return p.productId;
    return p.productRateCode;
  });
 
  const productRateCodes = _.keys(productGroup);

  // const discCookie = CookieCollection.DiscCookie.get();
  // var discount = 0;
  // if (discCookie && discCookie.code != '')
  // {
  //   discount = discCookie.per;
  // }

  _.forEach(productRateCodes, (productRateCode) => {
    const allDates = productGroup[productRateCode];
    const total = _.sum(
      _.map(allDates, function(p) {
        return p.totalRrp;
      })
    );
    const totalBeforeDiscount = _.sum(
      _.map(allDates, function(p) {
        return p.totalRrpBeforeDiscount;
      })
    );
    log.debug('productRateCode', productRateCode);
    const checkAvailabilityRet = checkAvailability(allDates, $this, nights);
    const available = checkAvailabilityRet.available;

    log.debug('available', available);

    const minAvailability = checkAvailabilityRet.minAvailability;
    const p = allDates[0];
    let radioHtmlAttributes = '';
    let buttonClassNames = '';
    if (available) {
      radioHtmlAttributes = '';
      buttonClassNames = 'btn-green ';
    } else {
      radioHtmlAttributes = 'disabled="disabled"';
      buttonClassNames = 'btn-red disabled ';
    }

    const $dataSelector = $(
      `.product-item[data-product-id=${productRateCode.split('|')[0]}]`
    );
    if (!$dataSelector) {
      console.error('dataSelector not found');
      return;
    }
    let productName: string;
    if ($dataSelector.length === 0) {
      productName = `Undefined Product ${p.productId}`;
    } else {
      productName = $dataSelector.first().data('name');
    }

    const totalRrp = total.toFixed(2);
    const totalRrpBeforeDiscount = totalBeforeDiscount.toFixed(2);

    const discountCookie = CookieCollection.DiscCookie.get();
    var discountCallOut = '';
    if (discountCookie)
    {
      discountCallOut = (discountCookie.callOutText).replace( /\+/g, ' ' );
    }

    const price = (totalRrp == totalRrpBeforeDiscount) ? available ? '$' + totalRrp : '' : available ? '<span class="fc-title discount">' + discountCallOut + '</span><br /><span class=\"strikediag\">$' + totalRrpBeforeDiscount + '</span> $' + totalRrp : '';
    log.debug('price', price);
    const pricePrefix = available ? 'Select' : 'Unavailable';
    const html = addToBasketTemplate({
      productId: p.productId,
      rateCode: p.rateCode,
      productRateCode: p.productRateCode,   
      rateName: rateName, 
      minAvailability: minAvailability,
      buttonClassNames: buttonClassNames,
      // buttonTitle: buttonTitle,
      productName: productName,
      total: total,
      price: price,
      totalBeforeDiscount: totalRrpBeforeDiscount,
      pricePrefix: pricePrefix,
      radioHtmlAttributes: radioHtmlAttributes
    });
    // $addToBasketList.append(html);  //move to list sorted by price (below)
    const productPrice: ProductPriceList = ({html: html, price: total});
    productPriceList.push(productPrice);
  });

  productPriceList.sort((a, b) => (a.price > b.price) ? 1 : -1);
  productPriceList.forEach(productPrice => $addToBasketList.append(productPrice.html));

  const $productSelectBtns = $('.product-price > .btn-green');
  log.debug('$productSelectBtns', $productSelectBtns.length);
  $productSelectBtns.off('click'); // clear event handlers
  $productSelectBtns.on('click', null, null, handleProductSelectButtonClicked);

  const hasSomeAvailability = $this.attr('data-any-availability') === 'true';

  if (
    !hasSomeAvailability &&
    ($this.hasClass('no-data') ||
      $this.hasClass('invalid-rrp') ||
      $this.hasClass('cta') ||
      $this.hasClass('ctd') ||
      $this.hasClass('stop-sell') ||
      $this.hasClass('invalid-min-nights') ||
      $this.hasClass('invalid-max-nights') ||
      $this.hasClass('stop-sell'))
  ) {
    log.debug(`rate-plan ${rateCode} is not available`);
  } else {
    $this.removeClass('hide');
    $this.addClass('available');
  }
}

export function setupRows(
  data: ProductPricingMulti,
  nights: number,
  paxsOfCurrentRoom: Pax[]
) {
  if (!data || !data.datePricing) {
    log.error('data or data.dataPricing should not be undefined');
    return;
  }

  const productSearch = CookieCollection.ProductSearch.get();
  if (!productSearch || !productSearch.branchId) {
    log.error('productSearch should not be undefined');
    return;
  }
  const { branchId } = productSearch;

  const datePricingGroup = _.groupBy<DatePricing>(
    data.datePricing,
    (x) => x.rateCode
  );
  const rateCodes = _.keys(datePricingGroup);
  const firstChild = _.find(paxsOfCurrentRoom, (c: Pax) => {
    return c.age < LEGAL_ADULT_AGE;
  });
  const hasChildren = firstChild != null;

  /**
   * .roomrow divs generated by server side in select-room.html
   * by default, roomrows are hidden
   */
  $('.roomrow').each((index, element) => {
    // @ts-ignore
    const $this = $(element);
    const adultOnlyRate = $this.data('adults-only-rate') as boolean;
    const rateCode = $this.data('rate-code') as number;
    const rateName = $this.data('rate-name') as string;

    log.debug('adultOnlyRate', adultOnlyRate);
    log.debug('hasChildren', hasChildren);

    if (!rateCode) {
      log.debug(`rate code ${rateCode} not set`);
      return;
    }

    if (hasChildren && adultOnlyRate == true) {
      log.debug(`rate code ${rateCode} is adult only rate`);
      return;
    }

    if (!_.find(rateCodes, (c) => c === rateCode.toString())) {
      log.debug(`rate code ${rateCode} does not exist in response data`);
      return;
    }

    const datePricingList = datePricingGroup[rateCode];
    setupRow(
      index,
      $this,
      branchId,
      rateCode.toString(),
      rateName.toString(),
      datePricingList,
      nights
    );
  });
}

export function autoSelectIfOnlyOneOptionAvailable() {
  const $availableRatePlanProductButtons = $(
    '.roomrow .product-price .btn-green'
  );
  if ($availableRatePlanProductButtons.length === 0) {
    $('.norooms').show();
    $('.roomsbrowser').hide();
    $('.checkout').hide();
  } else if ($availableRatePlanProductButtons.length === 1) {
    handleProductSelectButtonClicked({
      target: $availableRatePlanProductButtons[0],
      preventDefault: function() {}
    });
  }
}

export function getProductPricingMultiSuccess(
  data: ProductPricingMulti,
  nights: number
) {
  if (data && data.datePricing) {
    const productSearch = CookieCollection.ProductSearch.get();
    if (!productSearch) {
      log.error('productSearch should not be undefined');
      return;
    }

    const roomMax = getUrlParameter('roommax');
    if (!roomMax) {
      log.error('roomMax shall not be undefined');
      return;
    }

    const currentRoomId = getCurrentRoomId();
    if (!currentRoomId) {
      return;
    }

    const paxsOfCurrentRoom = _.filter(productSearch.paxs, (p) => {
      return p.room === currentRoomId;
    });
    log.debug('paxsOfCurrentRoom', paxsOfCurrentRoom);
    setupRows(data, nights, paxsOfCurrentRoom);
  }

  $('#loader').removeClass('show');

  // hide 'hide' class roomrows
  $('.roomrow.hide').hide();

  autoSelectIfOnlyOneOptionAvailable();
}

/**
 * Control visibility of room rows
 */
function showRooms() {
  const productSearch = CookieCollection.ProductSearch.get();
  if (!productSearch) {
    log.error('productSearch not set');
    return;
  }
  const branch = $('#branchId').val();
  if (!branch) {
    log.error('branch not set');
    return;
  }
  const start = getUrlParameter('s');
  if (!start) {
    log.error('start not set');
    return;
  }
  const end = getUrlParameter('e');
  if (!end) {
    log.error('end not set');
    return;
  }
  const currentRStr = getUrlParameter('rc');
  if (!currentRStr) {
    log.error('url parameter "rc" not set');
    return;
  }
  const currentR = parseInt(currentRStr);
  const paxs = productSearch.paxs;
  if (!paxs) {
    log.error('productSearch.paxs not set');
    return;
  }

  for (const pax of paxs) {
    const $adultSelector = $(
      `.roomsbrowser a[data-count="${pax.room}"] .adults`
    );
    const $childSelector = $(
      `.roomsbrowser a[data-count="${pax.room}"] .children`
    );

    let adultCount = parseInt($adultSelector.text());
    let childCount = parseInt($childSelector.text());

    if (!adultCount) {
      adultCount = 0;
    }
    if (!childCount) {
      childCount = 0;
    }

    if (pax.age == 18) {
      $adultSelector.text(adultCount + 1);
    } else {
      $childSelector.text(childCount + 1);
    }
  }

  const paxsInThisRoom: Pax[] = [];
  for (const pax of paxs) {
    if (pax.room == currentR) {
      const thisPax = {
        age: pax.age,
        room: pax.room,
        accessible: pax.accessible
      };
      paxsInThisRoom.push(thisPax);
    }
  }

  const mStart = moment(start);
  const mEnd = moment(end);
  const nights = mEnd.diff(mStart, 'days');
  var promo = productSearch.promoCode;
  if (typeof promo == 'undefined' || promo == 'undefined')
  {
    promo = '';
  }
  var discCode = CookieCollection.DiscCookie.get();
  var discount = '';
  if (typeof discCode != 'undefined')
  {
    discount = discCode.code;
  }
  
  // get products from API

  console.log('promoCode for select-room', promo);
  console.log('discCode for select-room', discount);

  const siteId = Number($('#siteId').val());      

  api
    .getProductPricingMulti(branch.toString(), siteId, start, end, paxsInThisRoom, promo, discount, false)
    .then((response) => {
      getProductPricingMultiSuccess(response.data, nights);
    })
    .catch((error) => {
      log.error('unable to request product pricing', error);
    });
}

export function getCurrentRoomId(): number | false {
  const currentRoomStr = getUrlParameter('rc');
  if (!currentRoomStr) {
    log.error('currentRoom shall not be undefined');
    return false;
  }
  return parseInt(currentRoomStr);
}

/**
 * Main function for select-room page
 */
export function run() {
  const productSearch = CookieCollection.ProductSearch.get();
  if (!productSearch) {
    log.error('productSearch should not be undefined');
    return;
  }

   // check for discCookie and if so REMOVE the promo code from ProductSearch
   const discountSearch = CookieCollection.DiscCookie.get();
   if (discountSearch)
   {
     if (discountSearch.code != '')
     {
       productSearch!.promoCode = '';
       CookieCollection.ProductSearch.set(productSearch!);
     }
   }

  const roomMax = getUrlParameter('roommax');
  if (!roomMax) {
    log.error('roomMax shall not be undefined');
    return;
  }

  const currentRoomId = getCurrentRoomId();
  if (!currentRoomId) {
    return;
  }

  // #region update title
  const paxs = _.filter(productSearch.paxs, (p: Pax) => {
    return p.room === currentRoomId;
  });
  const numOfAdults = _.reduce(paxs, (p, c) => (c.age >= 18 ? p + 1 : p), 0);
  const numOfChildren = paxs.length - numOfAdults;
  const textChildren =
    numOfChildren > 0
      ? ` ${numOfChildren} ${numOfChildren === 1 ? 'Child' : 'Children'}`
      : '';
  $('.paxs-details').text(
    `${numOfAdults} Adult${numOfAdults === 1 ? '' : 's'}${textChildren}`
  );
  // #endregion

  // if rooms has been selected
  const selectedRooms = CookieCollection.SelectedRooms.get();

  if (selectedRooms) {
    for (let i = 0; i < selectedRooms.length; i++) {
      $('.roomsbrowser a[data-count="' + selectedRooms[i].room + '"]').addClass(
        'done'
      );

      if (currentRoomId == selectedRooms[i].room) {
        // if current selected room is already in array, add selected to product that is chosen
        const currentRoom = selectedRooms[i];
        const productId = currentRoom.productId;
        $('.roomrow[data-id="' + productId + '"] .priceoptions p').addClass(
          'selected'
        );
      }
    }
  }

   // DATA LAYER //
    
   var adults = 0;
   var children = 0;
   var room = 0;
  
   CookieCollection.ProductSearch.get()?.paxs.forEach(paxCount);    
   function paxCount(pax :Pax, index)
   {
      if (pax.age > 17) adults++;
      if (pax.age < 18) children++;
      if (pax.room > room) room = pax.room;
   }

   var rooms = CookieCollection.SelectedRooms.get();
   
   var dataLayer = window.dataLayer = window.dataLayer || [];
   dataLayer.push({
   "event": "roomSelection",
   "checkIn": CookieCollection.Dates.get()?.checkIn,
   "checkOut": CookieCollection.Dates.get()?.checkOut,
   "page_level_1": $('#siteName').val(),
   "page_level_2": "select-room",
   "page_level_3": "",
   "page_level_4": "",
   "numberOfAdults": adults,
   "numberOfChildren": children,
   "roomCount": room
  });

   // DATA LAYER //

  $('#loader').addClass('show');
  // setTimeout(showrooms, 50);
  showRooms();
}
